import Service from "./Service";
const baseurl = '/api/historia-metodo-planificacion';
export default {
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    showByHc(id_historia) {
        return Service.get(`${baseurl}/show-by-hc/${id_historia}`);
    },
}